import { jsx as t, Fragment as n } from "react/jsx-runtime";
const c = ({ value: r }) => {
  if (r && r.length >= 11) {
    const s = r.replace(/\D/g, "");
    return /* @__PURE__ */ t(n, { children: s.substr(0, 3) + ".***.**" + s.substr(8, 1) + "-" + s.substr(9, 2) });
  }
  return /* @__PURE__ */ t(n, { children: r });
}, i = ({ value: r }) => {
  if (r && r.length >= 14) {
    const s = r.replace(/\D/g, "");
    return /* @__PURE__ */ t(n, { children: s.substr(0, 2) + "." + s.substr(2, 3) + "." + s.substr(5, 3) + "/" + s.substr(8, 4) + "-" + s.substr(12, 2) });
  }
  return /* @__PURE__ */ t(n, { children: r });
};
export {
  c as M,
  i as a
};
